<p-dialog
  [(visible)]="visible"
  [modal]="true"
  [closable]="true"
  [closeOnEscape]="true"
  [dismissableMask]="true"
  [draggable]="false"
  [focusOnShow]="true"
  [closeAriaLabel]="strings().closeAriaLabel"
  [header]="strings().header"
  styleClass="w-full max-w-[32rem]"
  (onHide)="onHide()"
>
  <div class="flex justify-center items-center mb-8">
    <p class="font-bold text-4xl" role="timer" aria-live="off">
      {{ countdownDisplay() }}
    </p>
  </div>
  <p class="mb-0">{{ strings().message }}</p>
  <ng-template pTemplate="footer">
    <p-button
      styleClass="p-button-text"
      [label]="strings().logOut"
      [disabled]="extending()"
      (onClick)="endSession()"
    ></p-button>
    <p-button
      [label]="strings().continueSession"
      [loading]="extending()"
      (onClick)="continueSession()"
    ></p-button>
  </ng-template>
</p-dialog>
